import { render } from "./OrderForm.vue?vue&type=template&id=0f06f824&scoped=true"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"

import "./OrderForm.vue?vue&type=style&index=0&id=0f06f824&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/proship-public-order/proship-public-order/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f06f824"]])

export default __exports__